import { Navigate } from "react-router-dom";
import LedgerAccountDetail from "./pages/ledger-account-details";
import LedgerOutlet from "./pages/ledger-outlet";
import LedgerAccounts from "./pages/ledger-account";
import PermissionGuard from "@/guards/permission-guard";
import { CAPABILITIES } from "@/config/permissions";

const LedgerRoutes = [
  {
    path: "/ledger",
    // Guard wraps the outlet so a user who types the URL directly (without the
    // role) is bounced, even though the menu link is already hidden for them.
    element: (
      <PermissionGuard capability={CAPABILITIES.LEDGER_ACCESS}>
        <LedgerOutlet />
      </PermissionGuard>
    ),
    children: [
      { index: true, element: <Navigate to="accounts" replace /> },
      { path: "accounts", element: <LedgerAccounts /> },
      { path: "accounts/:accountNumber", element: <LedgerAccountDetail /> },
    ],
  },
];

export default LedgerRoutes;
